export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10016.112fd09e.jpg";